/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'

const TypographyLazyRouteImport = createFileRoute('/typography')()
const TokensLazyRouteImport = createFileRoute('/tokens')()
const ColorsLazyRouteImport = createFileRoute('/colors')()
const BrandLazyRouteImport = createFileRoute('/brand')()
const IndexLazyRouteImport = createFileRoute('/')()

const TypographyLazyRoute = TypographyLazyRouteImport.update({
  id: '/typography',
  path: '/typography',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/typography.lazy').then((d) => d.Route))
const TokensLazyRoute = TokensLazyRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/tokens.lazy').then((d) => d.Route))
const ColorsLazyRoute = ColorsLazyRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/colors.lazy').then((d) => d.Route))
const BrandLazyRoute = BrandLazyRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/brand.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/brand': typeof BrandLazyRoute
  '/colors': typeof ColorsLazyRoute
  '/tokens': typeof TokensLazyRoute
  '/typography': typeof TypographyLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/brand': typeof BrandLazyRoute
  '/colors': typeof ColorsLazyRoute
  '/tokens': typeof TokensLazyRoute
  '/typography': typeof TypographyLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/brand': typeof BrandLazyRoute
  '/colors': typeof ColorsLazyRoute
  '/tokens': typeof TokensLazyRoute
  '/typography': typeof TypographyLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/brand' | '/colors' | '/tokens' | '/typography'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/brand' | '/colors' | '/tokens' | '/typography'
  id: '__root__' | '/' | '/brand' | '/colors' | '/tokens' | '/typography'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  BrandLazyRoute: typeof BrandLazyRoute
  ColorsLazyRoute: typeof ColorsLazyRoute
  TokensLazyRoute: typeof TokensLazyRoute
  TypographyLazyRoute: typeof TypographyLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/typography': {
      id: '/typography'
      path: '/typography'
      fullPath: '/typography'
      preLoaderRoute: typeof TypographyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tokens': {
      id: '/tokens'
      path: '/tokens'
      fullPath: '/tokens'
      preLoaderRoute: typeof TokensLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/colors': {
      id: '/colors'
      path: '/colors'
      fullPath: '/colors'
      preLoaderRoute: typeof ColorsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brand': {
      id: '/brand'
      path: '/brand'
      fullPath: '/brand'
      preLoaderRoute: typeof BrandLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  BrandLazyRoute: BrandLazyRoute,
  ColorsLazyRoute: ColorsLazyRoute,
  TokensLazyRoute: TokensLazyRoute,
  TypographyLazyRoute: TypographyLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
